import { useTranslation } from "react-i18next";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Chapter, Reveal } from "./shared";
import { LocalizedLink } from "../../lib/i18nRouting";
import { TERMS_PATH } from "../../data/holidays";

export default function HolidayFAQ() {
  const { t } = useTranslation();
  const items = t("holidays.faq.items", { returnObjects: true });
  return (
    <section id="faq" className="bg-bone py-24 lg:py-36 scroll-mt-20" data-testid="holidays-faq">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4 lg:sticky lg:top-28 self-start">
          <Chapter number={t("holidays.faq.chapter")} label={t("holidays.faq.eyebrow")} />
          <Reveal delay={0.1}>
            <h2 className="font-display text-5xl sm:text-6xl text-forest leading-[1.02] mt-8">
              {t("holidays.faq.title_a")}<br /><span className="italic">{t("holidays.faq.title_b")}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2} className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed">{t("holidays.faq.intro")}</Reveal>
        </div>

        <Reveal delay={0.15} className="lg:col-span-8">
          <Accordion type="single" collapsible className="border-t border-bone-deep" data-testid="faq-accordion">
            {items.map((it, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b border-bone-deep" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-6 text-left hover:no-underline gap-6 [&>svg]:text-terracotta [&>svg]:shrink-0" data-testid={`faq-trigger-${i}`}>
                  <span className="flex items-start gap-5">
                    <span className="font-display text-xl text-moss leading-none mt-0.5">{String(i + 1).padStart(2, "0")}</span>
                    <span className="font-display text-xl sm:text-2xl text-forest leading-snug">{it.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-7 pl-12 text-sm md:text-base text-muted-foreground leading-relaxed" data-testid={`faq-answer-${i}`}>
                  {it.a}
                  {it.link && (
                    <LocalizedLink to={TERMS_PATH} data-testid={`faq-terms-link-${i}`} className="block mt-3 text-xs uppercase tracking-wider-3 text-forest link-underline w-fit">
                      {t("holidays.terms.faq_link")} →
                    </LocalizedLink>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
